import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';

export default function ProviderChecklist() {
  const { user } = useAuthStore();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem('findr-checklist-dismissed') === '1'
  );

  if (dismissed) return null;

  const steps = [
    { label: 'Add a profile photo', done: !!user?.avatar, action: () => navigate('/account') },
    { label: 'Write a bio', done: !!user?.bio, action: () => navigate('/account') },
    { label: 'Set your location', done: !!user?.location, action: () => navigate('/account') },
    { label: 'Create your first listing', done: false, action: () => navigate('/create-service') },
    { label: 'Get verified', done: !!user?.isVerified, action: () => navigate('/verification') },
  ];

  const completed = steps.filter(s => s.done).length;
  const pct = Math.round((completed / steps.length) * 100);

  if (pct === 100) return null;

  return (
    <div className="mx-4 mb-6 bg-dark-surface border border-dark-border rounded-2xl overflow-hidden">
      <div className="flex items-center justify-between px-4 pt-4 pb-2">
        <div>
          <p className="text-dark-text font-semibold text-sm">Complete your profile</p>
          <p className="text-dark-subtext text-xs">{completed} of {steps.length} steps done</p>
        </div>
        <button
          onClick={() => { localStorage.setItem('findr-checklist-dismissed', '1'); setDismissed(true); }}
          className="text-dark-subtext/60 p-1"
          aria-label="Dismiss"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      {/* Progress bar */}
      <div className="px-4 mb-3">
        <div className="h-1.5 bg-dark-muted rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{ width: `${pct}%`, background: 'linear-gradient(90deg, #6C5CE7, #a855f7)' }}
          />
        </div>
        <p className="text-xs text-dark-subtext mt-1">{pct}% complete · Rank higher with a complete profile</p>
      </div>

      {/* Steps */}
      <div className="flex flex-col">
        {steps.map((step, i) => (
          <button
            key={i}
            onClick={step.done ? undefined : step.action}
            className={`flex items-center gap-3 px-4 py-3 border-t border-dark-border text-left transition-colors ${
              step.done ? 'cursor-default' : 'hover:bg-dark-muted/20 active:bg-dark-muted/30'
            }`}
          >
            <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${
              step.done ? 'bg-brand-purple border-brand-purple' : 'border-dark-border'
            }`}>
              {step.done && (
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              )}
            </div>
            <span className={`text-sm font-medium flex-1 ${
              step.done ? 'text-dark-subtext line-through' : 'text-dark-text'
            }`}>
              {step.label}
            </span>
            {!step.done && (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8E8E93" strokeWidth="2">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
